const InsightContentType = Object.freeze({
  SOUND_BITE: 'SOUND_BITE',
  HEADER_TWEET_SOUND_BITE: 'HEADER_TWEET_SOUND_BITE',
  COMMENT: 'COMMENT',
  DOMAIN: 'DOMAIN',
  TOP_AUTHOR: 'TOP_AUTHOR',

  // TopAuthors
  REPLIES: 'REPLIES',
  REPOSTS: 'REPOSTS',
  MENTIONS: 'MENTIONS',

  TOTAL_MEASURE: 'TOTAL_MEASURE',
  NAME_MEASURE: 'NAME_MEASURE',
  NAME_MEASURE_EMPTY: 'NAME_MEASURE_EMPTY',
  NAME_MEASURE_BY: 'NAME_MEASURE_BY',
  NAME_MEASURE_WITH_SHARE_OF_INSIGHTS: 'NAME_MEASURE_WITH_SHARE_OF_INSIGHTS',
  NAME_MEASURE_WITH_SHARE_OF_SENTIMENT: 'NAME_MEASURE_WITH_SHARE_OF_SENTIMENT',
  CROSSTAB_TOTAL_MEASURE: 'CROSSTAB_TOTAL_MEASURE',
  CROSSTAB_AVERAGE_MEASURE: 'CROSSTAB_AVERAGE_MEASURE',
  CROSSTAB_SELECTED_ITEM_MEASURE: 'CROSSTAB_SELECTED_ITEM_MEASURE',
  CROSSTAB_SHARE_OF_COLUMNS: 'CROSSTAB_SHARE_OF_COLUMNS',
  CROSSTAB_SHARE_OF_ROWS: 'CROSSTAB_SHARE_OF_ROWS',
  CROSSTAB_COLUMN_AVERAGE_DIFF: 'CROSSTAB_COLUMN_AVERAGE_DIFF',
  CROSSTAB_ROW_AVERAGE_DIFF: 'CROSSTAB_ROW_AVERAGE_DIFF',
  MEASURE_WITH_INSIGHTS: 'MEASURE_WITH_INSIGHTS',
  MEASURE_WITH_SENTIMENT: 'MEASURE_WITH_SENTIMENT',
  MEASURE_WITH_LOCAL_TIME: 'MEASURE_WITH_LOCAL_TIME',
  MEASURE_WITH_DEMO: 'MEASURE_WITH_DEMOGRAPHICS',
  MEASURE_WITH_DEMO_EMPTY: 'MEASURE_WITH_DEMOGRAPHICS_EMPTY',
  MEASURE_WITH_GEO: 'MEASURE_WITH_GEO',
  REGION_MEASURE: 'REGION_MEASURE',
  RESOLUTION_MEASURE: 'RESOLUTION_MEASURE',

  THING_LAYER_ONE: 'THING_LAYER_ONE',
  THING_LAYER_TWO: 'THING_LAYER_TWO',
  NET_SENTIMENT: 'NET_SENTIMENT',
  SENTIMENT_INSIGHT: 'SENTIMENT_INSIGHT',
  OVERALL_STAR_RATINGS_AVERAGE: 'OVERALL_STAR_RATINGS_AVERAGE',
  OVERALL_SURVEY_SCORES_AVERAGE: 'OVERALL_SURVEY_SCORES_AVERAGE',
  TRENDING_SINGLE_MEASURE: 'TRENDING_SINGLE_MEASURE',
  TRENDING_TOTAL_MEASURE: 'TRENDING_TOTAL_MEASURE',

  // topic comparison
  TOPIC_COMPARISON: 'TOPIC_COMPARISON',
  // photo concept
  PHOTO_CONCEPT: 'PHOTO_CONCEPT',
  PHOTO_CONCEPT_MEDIA: 'PHOTO_CONCEPT_MEDIA',

  // fluctuation
  FLUCTUATION_SUMMARY_METRICS: 'FLUCTUATION_SUMMARY_METRICS',
  FLUCTUATION_POPULAR_TERMS_PREREQUISITE: 'FLUCTUATION_POPULAR_TERMS_PREREQUISITE',
  FLUCTUATION_POPULAR_TERMS: 'FLUCTUATION_POPULAR_TERMS'
})
export default InsightContentType
export type InsightContentTypeStrings = typeof InsightContentType[keyof typeof InsightContentType]
// RESERVE BELOW
